var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.792,
    height: 14.74,
    viewBox: "0 0 15.792 14.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.556 -2.137)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.556 7.401)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.188,241.468H31.082a.526.526,0,0,0-.526.526v8.422a.526.526,0,0,0,.526.526h2.106a.526.526,0,0,0,.526-.526v-8.423A.526.526,0,0,0,33.188,241.468Z",
    transform: "translate(-30.556 -241.468)",
    fill: "#818c9f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.767 2.137)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.364,97.831a1.656,1.656,0,0,0-1.678-1.4h-4.1a9.089,9.089,0,0,0,.528-3.113,2.192,2.192,0,0,0-2.2-2.152h-.434a.526.526,0,0,0-.526.526c0,1.217-.474,3.414-1.368,4.308a5.831,5.831,0,0,1-1.791,1.157v7.9a12.3,12.3,0,0,0,4.342.849h3.443a1.6,1.6,0,0,0,1.579-2.161,1.58,1.58,0,0,0,1.053-2.106,1.58,1.58,0,0,0,.761-2.577A1.576,1.576,0,0,0,162.364,97.831Z",
    transform: "translate(-150.794 -91.172)",
    fill: "#818c9f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.8db4c5a6b201f6932b21372622373963.svg";
export { ForwardRef as ReactComponent };